import { render, staticRenderFns } from "./ProjectInfoDialog.vue?vue&type=template&id=9b2d8e2a&scoped=true"
import script from "./ProjectInfoDialog.vue?vue&type=script&lang=js"
export * from "./ProjectInfoDialog.vue?vue&type=script&lang=js"
import style0 from "./ProjectInfoDialog.vue?vue&type=style&index=0&id=9b2d8e2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b2d8e2a",
  null
  
)

export default component.exports